import { useSchool } from 'queries/schools';

/**
 * Determines if the school has Wonde import enabled (rather than CSV import)
 */
export const useWondeImportEnabled = () => {
  const { data: school } = useSchool();
  return school?.annotations['sparx.sync/controller-name'] === 'wonde';
};
